export default "__VITE_ASSET__BEhElEaR__"